import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

import {
  LegacyAllowanceProposal,
  LegacyBenefitProposal,
  LegacySalaryProposal,
} from '~/data/proposals';

import { ProposalWorkflowTablePropsType } from '../ProposalsWorkflowTables/common';

type ProposalsHistoryTableRowType =
  | LegacyAllowanceProposal
  | LegacyBenefitProposal
  | LegacySalaryProposal;

type PropsType = {
  columns: GridColDef[];
  rows: ProposalsHistoryTableRowType[];
  proposalWorkflowTable: React.ComponentType<ProposalWorkflowTablePropsType>;
  employeeId: number;
};
export const ProposalsHistoryTableLayout = (props: PropsType) => {
  const {
    columns,
    rows,
    proposalWorkflowTable: ProposalWorkflowTable,
    employeeId,
  } = props;

  const getDetailPanelContent = useCallback(
    ({ row }) => (
      <ProposalWorkflowTable
        employeeId={employeeId}
        employmentId={row.fEmplId}
        employmentSubUid={row.fEmplSubUId}
      />
    ),
    [ProposalWorkflowTable, employeeId],
  );

  return (
    <DataGridPro
      autoHeight={true}
      rows={rows}
      columns={columns}
      getRowId={(row: ProposalsHistoryTableRowType) => row.fEmplSubUId}
      getDetailPanelHeight={() => 'auto'}
      getDetailPanelContent={getDetailPanelContent}
    />
  );
};
